import { render, staticRenderFns } from "./dispatchSync.vue?vue&type=template&id=136d6252&scoped=true&"
import script from "./dispatchSync.vue?vue&type=script&lang=js&"
export * from "./dispatchSync.vue?vue&type=script&lang=js&"
import style0 from "./dispatchSync.vue?vue&type=style&index=0&id=136d6252&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136d6252",
  null
  
)

export default component.exports